import { Location } from "history";
import React from "react";

import { adminclubUrl } from "@/mk2/apps/adminclub/urls";
import { boUrl } from "@/mk2/apps/bo/urls";
import { dashUrl } from "@/mk2/apps/dash/urls";
import { usersTicketHelpUrl } from "@/mk2/apps/users/urls";
import { AdSlot } from "@/mk2/containers/AdSlot/AdSlot";

export const PREFIX_AD_SLOT_INTERSTITIAL = "mk-interstitial";

interface OwnProps {
    location: Location;
    isMobile: boolean;
    zone: string; // base name, napr. 'Forum - Interstitial'
}

type Props = OwnProps;

export const AdSlotInterstitial: React.FC<Props> = ({ location, isMobile, zone }) => {
    if (
        location.pathname.startsWith(boUrl) ||
        location.pathname.startsWith(adminclubUrl) ||
        location.pathname.startsWith(usersTicketHelpUrl) ||
        location.pathname.startsWith(dashUrl)
    ) {
        return null;
    }

    const finalZone = isMobile ? `${zone} - Mobile` : `${zone} - Desktop`;

    return (
        <AdSlot
            zone={finalZone}
            prefix={PREFIX_AD_SLOT_INTERSTITIAL}
            location={location}
            withoutDiv
        />
    );
};
